export const createSwedishErrorMessage = (statusCode: number): string => {
  switch (statusCode) {
    case 400:
      return 'Något gick fel. Försök igen.';
    case 401:
      return 'Obehörig åtkomst. Du måste logga in för att få tillgång till filen.';
    case 403:
      return 'Åtkomst nekad. Du har inte behörighet att se denna resurs.';
    case 404:
      return 'Resursen hittades inte.';
    case 500:
      return 'Internt serverfel. Försök igen senare.';
    default:
      return 'Ett okänt fel inträffade. Försök igen senare.';
  }
};
